<script>

import { Overlay } from '../../'

export default {
    name: 'MakersMove',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'Mano', version: '1.0.0',
                desc: 'MakersMove',
                preset: {
                    name: 'MakersMove',
                    group: 'Visual Trading',
                    side: 'onchart',
                    settings: {
                        lineWidth: 1
                    }
                }
            }
        },
        use_for() { return ['MakersMove'] },
        calc() {
            return {
                props: {
                },
                conf: { renderer: 'MM' }
            }
        }
    }
}
</script>
